export default class ContactUsRequest {
    constructor(fullName = '', email = '', phone = '', message = '') {
        this.fullName = fullName,
            this.email = email,
            this.phone = phone,
            this.message = message
    }
}